import { useState, useEffect } from 'react';
import useStore from '../../../store';

export const useMafiaMinigame = (game, mafia) => {
  useStore(state => state.render);

  const [showMiniGameIntro, setShowMiniGameIntro] = useState(false);
  const [showMiniGameUI, setShowMiniGameUI] = useState(false);

  // Достаем функцию из стора для обновления глобального флага
  const setMiniGamePlaying = useStore(state => state.setMiniGamePlaying);

  // ЭФФЕКТ 1: Управление жизненным циклом (Сброс и Инициализация)
  useEffect(() => {
    const isPeaceful = mafia.role === 'civilian';
    // Игровые фазы для мирных: пока мафия рисует или пока ночь
    const isGamingPhase = ['draw_mafia', 'night'].includes(mafia.phase);

    // 1. Если фаза сменилась на неигровую - сбрасываем всё моментально
    if (!isGamingPhase) {
      setShowMiniGameIntro(false);
      setShowMiniGameUI(false);
      return;
    }

    // 2. Логика старта: началась фаза мафии, мы мирный, есть игра, и мы еще ничего не показывали
    if (mafia.phase === 'draw_mafia' && isPeaceful && mafia.minigameType) {
        // Проверяем, что мы еще не в процессе
        if (!showMiniGameUI && !showMiniGameIntro) {
            setShowMiniGameIntro(true);
        }
    }
  }, [mafia.phase, mafia.role, mafia.minigameType, showMiniGameUI, showMiniGameIntro]);


  // ЭФФЕКТ 2: Изолированный таймер
  // Запускается ТОЛЬКО когда включается интро. Не зависит от фаз и ролей напрямую.
  useEffect(() => {
    if (showMiniGameIntro) {
        const delay = game?.mode === 'mafia' ? 4000 : 3000;

        const timer = setTimeout(() => {
            setShowMiniGameIntro(false);
            setShowMiniGameUI(true);
            // Автоматически переключаем таб на minigame
            mafia.methods.setActiveTab('minigame');
        }, delay);

        // Очистка таймера нужна, если игрок уйдет со страницы или фаза сменится (Эффект 1 сбросит intro в false)
        return () => clearTimeout(timer);
    }
  }, [showMiniGameIntro, game?.mode, mafia.methods]);


  // ЭФФЕКТ 3: Синхронизация с глобальным стором
  useEffect(() => {
    setMiniGamePlaying(showMiniGameUI);
    return () => setMiniGamePlaying(false);
  }, [showMiniGameUI, setMiniGamePlaying]);

  return {
    showMiniGameIntro,
    showMiniGameUI
  };
};